<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <el-select v-model="params.status" clearable>
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-link" @click="connectToMask" :disabled="connected">{{ connected ? "钱包已连接" : "连接钱包" }}</el-button>
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" highlight-current-row class="table-show-current">
            <el-table-column prop="id" align="center" label="订单ID" width="80"></el-table-column>
            <el-table-column prop="category" label="类型" align="center" width="100">
                <template slot-scope="scope">{{scope.row.category == 1?"借贷池订单":"杠杆池订单"}}</template>
            </el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{scope.row.memberAddress.slice(0,5) + "..." + scope.row.memberAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="总金额" align="center">
                <template slot-scope="scope">{{ scope.row.amount }}</template>
            </el-table-column>
            <el-table-column label="起息日" align="center" width="100">
                <template slot-scope="scope">{{ formatDate2(new Date(scope.row.profitStartAt)) }}</template>
            </el-table-column>
            <el-table-column label="累计收益" align="center" prop="orderProfit"></el-table-column>
            <el-table-column label="订单状态" align="center">
                <template slot-scope="scope"><span :class="'status_'+scope.row.status">{{ statusMap[scope.row.status] }}</span></template>
            </el-table-column>
            <el-table-column align="center" label="存入链上Hash" width="150" class-name="address">
                <template slot-scope="scope">
                    <a v-if="scope.row.buyTxHash" target="_blank" :href="getChainScan()+'/tx/'+scope.row.buyTxHash">{{showHash(scope.row.buyTxHash)}}</a>
                </template>
            </el-table-column>
            <el-table-column align="center" label="赎回链上Hash" width="150" class-name="address">
                <template slot-scope="scope">
                    <a v-if="scope.row.redeemTxHash" target="_blank" :href="getChainScan()+'/tx/'+scope.row.redeemTxHash">{{showHash(scope.row.redeemTxHash)}}</a>
                </template>
            </el-table-column>
            <el-table-column align="center" label="链上操作" width="200">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="handlePause(scope.row)">暂停</el-button>
                    <el-button type="success" size="mini" @click="handleResume(scope.row)">恢复</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { aldServiceApi  } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
import Web3 from 'web3';
export default {
    data() {
        return {
            params: {category:1},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
            // wallet
            walletAddress: "",
            connected: false,
            web3Instance: null,
            aldHomeContractInstance: null,
        };
    },
    created() {
        this.statusOptions = this.findDict("ALD_ORDER1_STATUS");
        this.statusMap = this.listToMap(this.statusOptions,"code","name");
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            aldServiceApi.findOrderPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        connectToMask(next){
            let _this = this;
            this.connectWallet(function(address){
                _this.walletAddress = address;
                _this.web3Instance  = new Web3(window.ethereum);
                _this.aldHomeContractInstance = new _this.web3Instance.eth.Contract(_this.AldHome_Contract.abi,_this.AldHome_Contract.address);
                _this.connected = true;
                if(typeof next === 'function'){
                    next();
                }
            });
        },
        handlePause(row){
            const exec = () => {
                const oid = row.oid;
                const orderId = row.id;
				alert(this.walletAddress);
                if(!oid){
                    this.$message.warning({message: "订单链上OID缺失",duration: 1500});
                    return;
                }
                if(!orderId){
                    this.$message.warning({message: "订单ID缺失",duration: 1500});
                    return;
                }
                this.showConfirmBox(2, '');
                this.contractSend(
                    this.aldHomeContractInstance.methods.pauseOrder(oid),
                    this.walletAddress,
                    0
                ).then((result)=>{
                    this.hideConfirmBox();
                    if(result && result.status){
                        // 合约暂停成功后，调用后台接口暂停分红
                        aldServiceApi.pauseOrder(orderId).then(res => {
                            if(res && res.result){
                                this.$message.success({message: "暂停成功",duration: 2000});
                                this.handleSearch();
                            }else{
                                if(res && res.msg){
                                    this.$message.error(res.msg);
                                }else{
                                    this.$message.error({message: "后台暂停分红失败",duration: 2000});
                                }
                            }
                        }).catch(() => {
                            this.$message.error({message: "调用后台暂停接口失败",duration: 2000});
                        });
                    }else{
                        this.$message.error({message: "暂停失败",duration: 1500});
                    }
                }).catch(()=>{
                    this.hideConfirmBox();
                    this.$message.error({message: "交易发送失败",duration: 1500});
                });
            };
            if(!this.connected){
                this.connectToMask(exec);
            }else{
                exec();
            }
        },
        handleResume(row){
            const exec = () => {
                const oid = row.oid;
                const orderId = row.id;
                if(!oid){
                    this.$message.warning({message: "订单链上OID缺失",duration: 1500});
                    return;
                }
                if(!orderId){
                    this.$message.warning({message: "订单ID缺失",duration: 1500});
                    return;
                }
                this.showConfirmBox(2, '');
                this.contractSend(
                    this.aldHomeContractInstance.methods.resumeOrder(oid),
                    this.walletAddress,
                    0
                ).then((result)=>{
                    this.hideConfirmBox();
                    if(result && result.status){
                        // 合约恢复成功后，调用后台接口恢复分红
                        aldServiceApi.resumeOrder(orderId).then(res => {
                            if(res && res.result){
                                this.$message.success({message: "恢复成功",duration: 2000});
                                this.handleSearch();
                            }else{
                                if(res && res.msg){
                                    this.$message.error(res.msg);
                                }else{
                                    this.$message.error({message: "后台恢复分红失败",duration: 2000});
                                }
                            }
                        }).catch(() => {
                            this.$message.error({message: "调用后台恢复接口失败",duration: 2000});
                        });
                    }else{
                        this.$message.error({message: "恢复失败",duration: 1500});
                    }
                }).catch(()=>{
                    this.hideConfirmBox();
                    this.$message.error({message: "交易发送失败",duration: 1500});
                });
            };
            if(!this.connected){
                this.connectToMask(exec);
            }else{
                exec();
            }
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['订单ID','产品名称','类型','会员地址',
            '购买时间','购买数量','购买单价','总金额','当前价值','起息日','计息结束日',
            '实际每日年化','实际阶梯年化','累计收益','最近领取时间',
            "订单状态","续订状态",
            '申请赎回时间','实际赎回价值','赎回手续费','完成赎回时间',"更新时间"];

            let columns = ['id', 'name','type','memberAddress',
            'buyAt', 'numKeep', 'priceOld', 'valuePay',"curTotalValue","profitStartAt",'profitEndAt',
            "apyDay","apyLadder","sumProfitSelf",'takeRemainAt','status','renewalFlag',
            "redeemApplyAt","redeemValue","redeemFee",'redeemFinishAt','updatedAt',
        ];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                if(c == 'curTotalValue'){
                    return r["priceCur"] * r["numKeep"];
                }
                return val; 
            }));
            exportData2(header,data,"订单数据");
        }
    }
};
</script>
<style lang='less' scope>
span.status_NORMAL{
    color:#ffffff;
    background-color: green;
    padding: 2px 10px;
    border-radius: 20px;
}
span.status_REDEEM_FINISH{
    color:#aaaaaa;
    background-color: #dddddd;
    padding: 2px 10px;
    border-radius: 20px;
}
</style>